import type { UtilityContext } from '@change-corgi/core-react/utilityContext';

import { NotFoundError } from '#src/shared/error';

import type { MiscContentDetailsDataQuery, MiscContentDetailsDataQueryVariables } from './api.graphql';
import { MiscContentDetailsData } from './api.graphql';

export type MiscContentDetailsPageData = {
	countryCode: string;
	details: NonNullable<MiscContentDetailsDataQuery['details']>;
};

export async function getMiscContentDetailsPageData(
	{ gql: { fetch } }: UtilityContext,
	{ countryCode, locale, slug }: { countryCode: string; locale: string; slug: string },
): Promise<MiscContentDetailsPageData> {
	const { data } = await fetch<MiscContentDetailsDataQuery, MiscContentDetailsDataQueryVariables>({
		query: MiscContentDetailsData,
		variables: { countryCode, locale, slugOrId: slug },
		rejectOnError: true,
	});

	if (!data?.details) {
		throw new NotFoundError();
	}

	return {
		countryCode,
		details: data.details,
	};
}
